




































































import Vue from 'vue';
import CompanyInfo from '@/components/CompanyInfo.vue';

export default Vue.extend({
    components: {
        CompanyInfo,
    },
    data() {
        return {
            progress: [
                {
                    img: require('../../assets/images/manufacturer/img_fabuchanping.png'),
                    title: 'publish products',
                    name: '发布产品',
                    content: [
                        '通过标准化认证体系为您的产品提供标准化认证服务，并将产品编码、参数信息等数据打包发布。',
                        '将产品在iBuilding3D平台上发布，可确保任何设计人员都能快速找到、查看您的产品信息，并可以高效便捷的将产品应用到他们的项目中。',
                    ],
                },
                {
                    img: require('../../assets/images/manufacturer/img_chanpingshichang.png'),
                    title: 'produce market',
                    name: '产品市场',
                    content: [
                        'iBuilding3D庞大、精准的用户生群让其成为您将品牌推向新市场的理想之地。',
                        '以产品信息模型及产品数据为桥梁，搭建您与设计师、施工人员以及业主间的沟通渠道，您可以方便的联系到下载产品的目标客户。',
                    ],
                },
                {
                    img: require('../../assets/images/manufacturer/img_chanpingshuju.png'),
                    title: 'Product data',
                    name: '产品数据',
                    content: [
                        '更好的数据意味着更明智的决策，iBuilding3D帮助您准确了解产品需求，帮助您挖掘新客户，帮助您充满信心的将产品推向新市场。',
                        'iBuilding3D管理后台的数据统计，可让您按用户细分、市场、产品类别等跟踪和分析产品的应用情况。',
                    ],
                },
            ],
            help: [
                {
                    img: require('../../assets/images/manufacturer/img_jihua.png'),
                    name: '计划',
                    content: '我们与您的产品团队一起，基于您预计发布的产品制定、发布计划',
                },
                {
                    img: require('../../assets/images/manufacturer/img_zhunbei.png'),
                    name: '准备',
                    content: '我们的项目经理可以帮助您收集产品BIM族文件制作所需的所有必要数据',
                },
                {
                    img: require('../../assets/images/manufacturer/img_shengchan.png'),
                    name: '生产',
                    content: '借助经验丰富的BIM模型制作团队和智能开发工具，我们将按照规范的制作您的产品',
                },
                {
                    img: require('../../assets/images/manufacturer/img_fabu.png'),
                    name: '发布',
                    content: '当您确认我们的交付成果后，我们会通过管理后台将您的产品发布到iBuilding3D上',
                },
            ],
        };
    },
    methods: {
        toProducts() {
            this.$router.push({
                path: '/products',
            });
        },
    },
});
